import { useTranslation } from 'react-i18next';

/** @graph-connects none */
export function formatAnalyzedAt(iso: string): string {
  const d = new Date(iso);
  const jst = new Date(d.getTime() + 9 * 60 * 60 * 1000);
  const y = jst.getUTCFullYear();
  const m = String(jst.getUTCMonth() + 1).padStart(2, '0');
  const day = String(jst.getUTCDate()).padStart(2, '0');
  const h = String(jst.getUTCHours()).padStart(2, '0');
  const min = String(jst.getUTCMinutes()).padStart(2, '0');
  return `${String(y)}/${m}/${day} ${h}:${min}`;
}

/** @graph-connects none */
interface AiAnalysisHistoryItem {
  id: string;
  from: string;
  to: string;
  analyzedAt: string;
  analyzedBy: string;
}

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business AI 分析の履歴テーブル。実行日時・期間・実行者・サマリを表示し、行クリックで詳細を開く。
 * @graph-connects none
 */
export function AiAnalysisHistoryTable<T extends AiAnalysisHistoryItem>({
  items,
  onSelect,
  getSummary,
}: {
  items: T[];
  onSelect: (item: T) => void;
  getSummary: (item: T) => string;
}) {
  const { t } = useTranslation();

  if (items.length === 0) {
    return <p className="py-8 text-center text-sm text-gray-400">{t('aiAnalysis.noHistory')}</p>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b text-xs text-gray-500">
            <th className="px-4 py-2 font-medium">{t('aiAnalysis.executedAt')}</th>
            <th className="px-4 py-2 font-medium">{t('aiAnalysis.analysisPeriod')}</th>
            <th className="px-4 py-2 font-medium">{t('aiAnalysis.executor')}</th>
            <th className="px-4 py-2 font-medium">{t('aiAnalysis.summary')}</th>
            <th className="px-4 py-2" />
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr
              key={item.id}
              className="cursor-pointer border-b hover:bg-blue-50"
              onClick={() => {
                onSelect(item);
              }}
            >
              <td className="whitespace-nowrap px-4 py-3">{formatAnalyzedAt(item.analyzedAt)}</td>
              <td className="whitespace-nowrap px-4 py-3 text-gray-500">
                {item.from} 〜 {item.to}
              </td>
              <td className="px-4 py-3 text-gray-500">{item.analyzedBy.split('@')[0]}</td>
              <td className="max-w-[400px] truncate px-4 py-3 text-gray-500">{getSummary(item)}</td>
              <td className="px-4 py-3 text-xs font-medium text-blue-600">{t('common.detail')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
